// extracted by mini-css-extract-plugin
export default {"testMode":"Nf_dN8Ogc7rP4EIuhOrh"};